export default "<viz-stacked-story-count filter-set=\"filterSet\" on-detail-view=\"true\"></viz-stacked-story-count>\n";